const workflowConstants = {
  lg: {
    size: 1100,
    panelTitlePadding: '16px 24px',
    panelContainerPaddingHorizontal: '24px',
    accordionTitlePadding: '4px 24px',
  },
  md: {
    size: 767,
    panelTitlePadding: '10px 16px',
    panelContainerPaddingHorizontal: '16px',
    accordionTitlePadding: '4px 16px',
  },
  sm: {
    size: 645,
    panelTitlePadding: '10px 16px',
    panelContainerPaddingHorizontal: '16px',
    accordionTitlePadding: '4px 16px',
  },
};

export default workflowConstants;
